import { useUnit } from 'effector-react'

import {
  $totalCountOfWinners,
  getWinners,
  winnersListMounted,
  $winners,
} from './model'
import { WinnersRequest } from './types'

export const useWinnersList = () => {
  const winners = useUnit($winners)
  const loading = useUnit(getWinners.pending)
  const totalCountOfWinners = useUnit($totalCountOfWinners)

  const onChangeWinnersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: WinnersRequest) => {
    winnersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    winners,
    totalCountOfWinners,
    loading,
    onChangeWinnersList,
  }
}
